/** Reuse already loaded, owner-scoped identity data; never infer addresses from domains. */
export function ownedRecipientOptions(
  profile: { id?: number; email?: string | null; privateEmail?: string | null; backupEmail?: string | null; fullName?: string | null; firstName?: string | null; lastName?: string | null } | undefined,
  identities: Array<{ id: number; email: string; displayName?: string | null }>,
  search: string,
) {
  const normalize = (value: string) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const terms = normalize(search).split(/\s+/).filter(Boolean);
  if (!terms.length) return [];
  const name = profile?.fullName || [profile?.firstName, profile?.lastName].filter(Boolean).join(' ') || 'Il tuo indirizzo';
  const candidates = [
    ...[profile?.email, profile?.privateEmail, profile?.backupEmail].map(email => ({ email, name, id: profile?.id ?? 0 })),
    ...identities.map(identity => ({ email: identity.email, name: identity.displayName || name, id: identity.id })),
  ];
  const seen = new Set<string>();
  return candidates.flatMap(candidate => {
    const email = candidate.email?.trim().toLowerCase();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || seen.has(email)) return [];
    if (!terms.every(term => normalize(`${name} ${candidate.name} ${email}`).includes(term))) return [];
    seen.add(email);
    return [{ email, label: candidate.name, detail: 'Il tuo indirizzo', source: 'identity' as const, entityId: candidate.id }];
  });
}
